module.exports = __webpack_public_path__ + "img/伯才直聘.3bf39c53.png";